/* eslint-disable @typescript-eslint/no-var-requires */
window.htmx = require("htmx.org").default
